export function trackEvent(name, data = {}) {
  if (typeof navigator?.sendBeacon !== 'function') return;
  try {
    navigator.sendBeacon('/api/events', JSON.stringify({
      event: name,
      ...data,
      ts: Date.now(),
      url: window.location.pathname,
    }));
  } catch {
    // Silent fail — analytics should never break the app
  }
}

// Tracking functions for key metrics
export function trackSignup() { trackEvent('signup_complete'); }
export function trackTrialStart() { trackEvent('trial_start'); }
export function trackTrialEnd(converted) { trackEvent('trial_end', { converted }); }
export function trackSubscribe(plan, interval) { trackEvent('subscribe', { plan, interval }); }
export function trackReportGenerate(tier) { trackEvent('report_generate', { tier }); }
export function trackReportDownload(tier, type) { trackEvent('report_download', { tier, type }); } // type: 'estimate'|'internal'|'pl'
export function trackClientCreate() { trackEvent('client_create'); }
export function trackAddressSearch(market) { trackEvent('address_search', { market }); }
export function trackServiceSelect(services) { trackEvent('service_select', { count: services.length }); }
export function trackMeasurementConfirm() { trackEvent('measurement_confirm'); }
export function trackMeasurementAdjust() { trackEvent('measurement_adjust'); }
export function trackPhotoUpload(count) { trackEvent('photo_upload', { count }); }
export function trackCrmOpen() { trackEvent('crm_open'); }
export function trackPageView(screen) { trackEvent('page_view', { screen }); }
